import { Reveal } from "./Reveal";

const DISHES = [
  {
    no: "01",
    name: "Ember & Ash",
    desc: "Charred leek heart, black garlic velouté, smoked trout roe and a whisper of burnt citrus — our most requested opening course.",
    pairing: "Pairs with — Chablis, Premier Cru",
    img: "https://images.pexels.com/photos/38431749/pexels-photo-38431749.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Elegantly plated gourmet dish on stacked plates",
  },
  {
    no: "02",
    name: "The Pearl Bar",
    desc: "Kumamoto oysters on crushed ice with champagne mignonette, sea herbs and pickled shallot — a raw bar staged tableside.",
    pairing: "Pairs with — Blanc de Blancs",
    img: "https://images.unsplash.com/photo-1779635593752-232a6e3c82db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxnb3VybWV0JTIwcGxhdGVkJTIwZGlzaCUyMGx1eHVyeSUyMHJlc3RhdXJhbnQlMjBjaGVmJTIwY2F0ZXJpbmd8ZW58MHx8fHwxNzkyNzk3NTU5fDA&ixlib=rb-4.1.0&q=85",
    alt: "Fresh oysters on ice with floral garnish",
  },
  {
    no: "03",
    name: "Gilded Berry",
    desc: "Vanilla bean panna cotta, macerated raspberries, rose sugar and a single leaf of gold — dessert as the final brushstroke.",
    pairing: "Pairs with — Late-Harvest Riesling",
    img: "https://images.unsplash.com/photo-1651842461850-2bd499a2ed54?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxmaW5lJTIwZGluaW5nJTIwcGxhdGVkJTIwZ291cm1ldCUyMGZvb2QlMjBjYXRlcmluZyUyMGhlcm98ZW58MHx8fHwhfHwxNzkyNzk3NTU5fDA&ixlib=rb-4.1.0&q=85",
    alt: "Delicate fine dining plated dessert with red berry compote",
  },
];

export const SignatureDishes = () => (
  <section id="dishes" data-testid="signature-dishes-section" className="bg-linen py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="mb-16 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <Reveal>
          <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-ink-mute">
            The Beaumont Table — Signature Courses
          </p>
          <h2 className="max-w-xl font-serif text-3xl leading-tight tracking-tight text-noir sm:text-4xl lg:text-5xl">
            Menus composed like <span className="italic text-truffle">architecture</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="max-w-sm text-sm leading-relaxed text-ink-mute">
            Every engagement begins with a tasting. These three courses anchor
            the current season's repertoire — sample menu, rewritten monthly.
          </p>
        </Reveal>
      </div>

      <div className="grid gap-10 md:grid-cols-3 md:gap-8">
        {DISHES.map((dish, i) => (
          <Reveal
            key={dish.no}
            delay={i * 0.12}
            className={i === 1 ? "md:translate-y-12" : ""}
          >
            <article
              data-testid={`dish-card-${dish.no}`}
              className="group"
            >
              <div className="arch-frame relative overflow-hidden border border-noir/10 transition-[border-color,box-shadow] duration-500 group-hover:border-gold/50 group-hover:shadow-[0_30px_60px_-25px_rgba(92,64,51,0.35)]">
                <img
                  src={dish.img}
                  alt={dish.alt}
                  loading="lazy"
                  className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.05]"
                />
                <span className="absolute top-5 left-1/2 -translate-x-1/2 rounded-full border border-bone/40 bg-noir/45 px-4 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-bone backdrop-blur-md">
                  Course {dish.no}
                </span>
              </div>
              <div className="mt-6 px-1">
                <h3 className="font-serif text-xl text-noir sm:text-2xl">
                  <span className="mr-2 font-mono text-xs text-gold">{dish.no}</span>
                  {dish.name}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-soft">{dish.desc}</p>
                <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-truffle">
                  {dish.pairing}
                </p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
